import React from 'react';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import ProductTagService from '../../services/ProductTagService';

const TagsBadges = ({ tags }) => {
  if (!tags || !tags.length) return null;

  const nonInternalTags = tags.filter((tag) => !tag.isInternal);
  if (!nonInternalTags || !nonInternalTags.length) return null;

  return nonInternalTags.map((tag, index) => {
    const description = ProductTagService.getProductTagDisplayValue(
      tag.description,
    );
    const urlEncodedLink = ProductTagService.getProductTagUrlValue(
      tag.description,
    );

    return (
      <Button key={`tag-${urlEncodedLink}`}>
        <Link
          key={`tag-${urlEncodedLink}`}
          to={`/shop/${urlEncodedLink}`}
        >{`${description}${
          index < nonInternalTags.length - 1 ? ' ' : ''
        }`}</Link>
      </Button>
    );
  });
};

export default TagsBadges;
